import React, { useState, useMemo } from 'react';
import TopNavbar from '../../home/TopNavbar';

// Data parsed cleanly from your JEE Main physics weightage table
const rawPhysicsData = [
  // Class XIth Physics
  { class: 'Class XIth Physics', sno: 1, chapter: 'Mathematical Tools', weightage: 0.00 },
  { class: 'Class XIth Physics', sno: 2, chapter: 'Units and Measurements', weightage: 4.24 },
  { class: 'Class XIth Physics', sno: 3, chapter: 'Motion in a Straight Line', weightage: 2.63 },
  { class: 'Class XIth Physics', sno: 4, chapter: 'Motion in a Plane', weightage: 2.92 },
  { class: 'Class XIth Physics', sno: 5, chapter: 'Newton’s Laws of Motion', weightage: 2.05 },
  { class: 'Class XIth Physics', sno: 6, chapter: 'Work, Energy & Power', weightage: 2.37 },
  { class: 'Class XIth Physics', sno: 7, chapter: 'Centre of Mass & System of Particles', weightage: 2.56 },
  { class: 'Class XIth Physics', sno: 8, chapter: 'Rotational Motion', weightage: 4.31 },
  { class: 'Class XIth Physics', sno: 9, chapter: 'Gravitation', weightage: 4.49 },
  { class: 'Class XIth Physics', sno: 10, chapter: 'Mechanical Properties of Solids', weightage: 2.08 },
  { class: 'Class XIth Physics', sno: 11, chapter: 'Mechanical Properties of Fluids', weightage: 3.00 },
  { class: 'Class XIth Physics', sno: 12, chapter: 'Thermal Properties of Matter', weightage: 2.08 },
  { class: 'Class XIth Physics', sno: 13, chapter: 'Kinetic Theory of Gases', weightage: 2.88 },
  { class: 'Class XIth Physics', sno: 14, chapter: 'Thermodynamics', weightage: 3.06 },
  { class: 'Class XIth Physics', sno: 15, chapter: 'Oscillations', weightage: 3.25 },
  { class: 'Class XIth Physics', sno: 16, chapter: 'Waves', weightage: 1.94 },

  // Class XIIth Physics
  { class: 'Class XIIth Physics', sno: 1, chapter: 'Electric Charges and Fields', weightage: 3.18 },
  { class: 'Class XIIth Physics', sno: 2, chapter: 'Electrostatic Potential and Capacitance', weightage: 4.49 },
  { class: 'Class XIIth Physics', sno: 3, chapter: 'Current Electricity', weightage: 6.57 },
  { class: 'Class XIIth Physics', sno: 4, chapter: 'Moving Charges and Magnetism', weightage: 2.89 },
  { class: 'Class XIIth Physics', sno: 5, chapter: 'Magnetism and Matter', weightage: 1.90 },
  { class: 'Class XIIth Physics', sno: 6, chapter: 'Electromagnetic Induction', weightage: 3.25 },
  { class: 'Class XIIth Physics', sno: 7, chapter: 'Alternating Current', weightage: 3.73 },
  { class: 'Class XIIth Physics', sno: 8, chapter: 'Electromagnetic Waves', weightage: 2.96 },
  { class: 'Class XIIth Physics', sno: 9, chapter: 'Ray Optics and Optical Instruments', weightage: 5.04 },
  { class: 'Class XIIth Physics', sno: 10, chapter: 'Wave Optics', weightage: 2.30 },
  { class: 'Class XIIth Physics', sno: 11, chapter: 'Dual Nature of Radiation and Matter', weightage: 4.05 },
  { class: 'Class XIIth Physics', sno: 12, chapter: 'Atoms', weightage: 2.48 },
  { class: 'Class XIIth Physics', sno: 13, chapter: 'Nuclei', weightage: 3.14 },
  { class: 'Class XIIth Physics', sno: 14, chapter: 'Semiconductor Electronics: Materials, Devices and Simple Circuits', weightage: 4.75 },
];

export default function ChapterWiseWeightagePhysicsTopics() {
  const [selectedClass, setSelectedClass] = useState('ALL');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('weightage-desc');

  const maxWeightage = useMemo(() => Math.max(...rawPhysicsData.map((i) => i.weightage)), []);

  const filteredData = useMemo(() => {
    return rawPhysicsData
      .filter((item) => {
        const matchesClass = selectedClass === 'ALL' || item.class === selectedClass;
        const matchesSearch = item.chapter.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesClass && matchesSearch;
      })
      .sort((a, b) => {
        if (sortBy === 'weightage-desc') return b.weightage - a.weightage;
        if (sortBy === 'weightage-asc') return a.weightage - b.weightage;
        if (sortBy === 'alphabetical') return a.chapter.localeCompare(b.chapter);
        return 0;
      });
  }, [selectedClass, searchTerm, sortBy]);

  const stats = useMemo(() => {
    const class11Total = rawPhysicsData
      .filter((d) => d.class === 'Class XIth Physics')
      .reduce((acc, curr) => acc + curr.weightage, 0);
    const class12Total = rawPhysicsData
      .filter((d) => d.class === 'Class XIIth Physics')
      .reduce((acc, curr) => acc + curr.weightage, 0);
    const highWeightCount = rawPhysicsData.filter((d) => d.weightage >= 4.0).length;
    const topTopic = [...rawPhysicsData].sort((a, b) => b.weightage - a.weightage)[0];
    return { class11Total, class12Total, highWeightCount, topTopic };
  }, []);

  return (
    <>
      <style>{`
        .jeew-container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 24px 16px;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          color: #1f2937;
          background-color: #f9fafb;
          min-height: 100vh;
          margin-top: 50px;
          margin-bottom: 50px;
        }
        .jeew-header {
          text-align: center;
          margin-bottom: 24px;
        }
        .jeew-header h1 {
          font-size: 1.85rem;
          font-weight: 800;
          color: #111827;
          margin: 0 0 8px 0;
        }
        .jeew-header p {
          color: #4b5563;
          font-size: 0.95rem;
          line-height: 1.5;
          max-width: 750px;
          margin: 0 auto;
        }
        .jeew-stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
          gap: 16px;
          margin-bottom: 24px;
        }
        .jeew-stat-card {
          background: #ffffff;
          padding: 16px;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.08);
          border: 1px solid #e5e7eb;
        }
        .jeew-stat-label {
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: #6b7280;
          font-weight: 600;
          margin-bottom: 4px;
        }
        .jeew-stat-value {
          font-size: 1.35rem;
          font-weight: 700;
          color: #0d9488;
        }
        .jeew-stat-sub {
          font-size: 0.75rem;
          color: #9ca3af;
          margin-top: 2px;
        }
        .jeew-controls {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          justify-content: space-between;
          align-items: center;
          background: #ffffff;
          padding: 16px;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          margin-bottom: 20px;
        }
        .jeew-tabs {
          display: flex;
          gap: 6px;
        }
        .jeew-tab-btn {
          padding: 8px 16px;
          border-radius: 8px;
          font-size: 0.85rem;
          font-weight: 600;
          border: 1px solid #d1d5db;
          background: #f3f4f6;
          color: #374151;
          cursor: pointer;
          transition: all 0.2s;
        }
        .jeew-tab-btn.active {
          background: #0d9488;
          color: #ffffff;
          border-color: #0d9488;
        }
        .jeew-filter-group {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        .jeew-input, .jeew-select {
          padding: 8px 12px;
          border-radius: 8px;
          border: 1px solid #d1d5db;
          font-size: 0.85rem;
          background: #fff;
          color: #1f2937;
        }
        .jeew-table-wrapper {
          background: #ffffff;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          overflow-x: auto;
          box-shadow: 0 1px 3px rgba(0,0,0,0.06);
        }
        .jeew-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
          font-size: 0.9rem;
        }
        .jeew-table th, .jeew-table td {
          padding: 12px 16px;
          border-bottom: 1px solid #f3f4f6;
        }
        .jeew-table th {
          background: #f8fafc;
          font-weight: 600;
          color: #374151;
          font-size: 0.8rem;
          text-transform: uppercase;
          letter-spacing: 0.03em;
        }
        .jeew-bar-container {
          background: #e5e7eb;
          height: 8px;
          border-radius: 4px;
          width: 120px;
          overflow: hidden;
        }
        .jeew-bar-fill {
          height: 100%;
          background: #0d9488;
          border-radius: 4px;
        }
        .jeew-badge {
          display: inline-block;
          padding: 2px 8px;
          border-radius: 999px;
          font-size: 0.75rem;
          font-weight: 600;
        }
        .jeew-badge-high {
          background: #ccfbf1;
          color: #0f766e;
        }
        .jeew-badge-class {
          background: #f1f5f9;
          color: #475569;
          font-size: 0.7rem;
        }
        .jeew-empty {
          text-align: center;
          padding: 32px;
          color: #6b7280;
        }
      `}</style>

      <div className="jeew-container">

              <TopNavbar name="Physics Weightage" ></TopNavbar>

        <header className="jeew-header">
          <h3 style={{color: "green"}}>JEE Main Past 5 Years Chapter-wise Weightage for Physics</h3>
          <p>
            The table below shows how many questions were asked from each Physics chapter over the last five years. Analysing this data can help prioritise topics during preparation.
          </p>
        </header>

        <div className="jeew-stats-grid">
          <div className="jeew-stat-card">
            <div className="jeew-stat-label">Top Scoring Topic</div>
            <div className="jeew-stat-value">{stats.topTopic?.weightage}%</div>
            <div className="jeew-stat-sub">{stats.topTopic?.chapter}</div>
          </div>
          <div className="jeew-stat-card">
            <div className="jeew-stat-label">High-Impact Topics (&gt;4%)</div>
            <div className="jeew-stat-value">{stats.highWeightCount} Chapters</div>
            <div className="jeew-stat-sub">High priority scoring zones</div>
          </div>
          <div className="jeew-stat-card">
            <div className="jeew-stat-label">Class XIth Weight Sum</div>
            <div className="jeew-stat-value">{stats.class11Total.toFixed(2)}%</div>
            <div className="jeew-stat-sub">16 total chapters tracked</div>
          </div>
          <div className="jeew-stat-card">
            <div className="jeew-stat-label">Class XIIth Weight Sum</div>
            <div className="jeew-stat-value">{stats.class12Total.toFixed(2)}%</div>
            <div className="jeew-stat-sub">14 total chapters tracked</div>
          </div>
        </div>

        <div className="jeew-controls">
          <div className="jeew-tabs">
            <button
              className={`jeew-tab-btn ${selectedClass === 'ALL' ? 'active' : ''}`}
              onClick={() => setSelectedClass('ALL')}
            >
              All Classes
            </button>
            <button
              className={`jeew-tab-btn ${selectedClass === 'Class XIth Physics' ? 'active' : ''}`}
              onClick={() => setSelectedClass('Class XIth Physics')}
            >
              Class XIth
            </button>
            <button
              className={`jeew-tab-btn ${selectedClass === 'Class XIIth Physics' ? 'active' : ''}`}
              onClick={() => setSelectedClass('Class XIIth Physics')}
            >
              Class XIIth
            </button>
          </div>

          <div className="jeew-filter-group">
            <input
              type="text"
              placeholder="Search chapters..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="jeew-input"
            />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="jeew-select"
            >
              <option value="weightage-desc">Weightage: High to Low</option>
              <option value="weightage-asc">Weightage: Low to High</option>
              <option value="alphabetical">Alphabetical (A-Z)</option>
            </select>
          </div>
        </div>

        <div className="jeew-table-wrapper">
          <table className="jeew-table">
            <thead>
              <tr>
                <th>Class</th>
                <th>S. No.</th>
                <th>Chapter Name</th>
                <th>Weightage Share</th>
                <th>Relative Weight</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((row, idx) => {
                  const percentWidth = Math.min(100, (row.weightage / maxWeightage) * 100);
                  return (
                    <tr key={`${row.class}-${row.sno}-${idx}`}>
                      <td>
                        <span className="jeew-badge jeew-badge-class">
                          {row.class.replace(' Physics', '')}
                        </span>
                      </td>
                      <td>{row.sno}</td>
                      <td><strong>{row.chapter}</strong></td>
                      <td>
                        <span
                          className={`jeew-badge ${row.weightage >= 4.0 ? 'jeew-badge-high' : ''
                            }`}
                        >
                          {row.weightage.toFixed(2)}%
                        </span>
                      </td>
                      <td>
                        <div className="jeew-bar-container">
                          <div
                            className="jeew-bar-fill"
                            style={{ width: `${percentWidth}%` }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="jeew-empty">
                    No matching chapters found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}